module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79c82b12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common-template/AccountAdminHeader.vue
// module id = 1484
// module chunks = 7